export default "__VITE_ASSET__CwYTU4Gj__"